<template>
    <div class="max-view-shell">
        <div class="w-view-shell">
            <div class="pay-succed-shell" v-if="is_order">
                <img src="@/assets/pitch.png" alt=""/>
                <div class="tips">支付成功</div>
            </div>
            <div class="goods-info-shell">
                <div class="info-header">
                    <div class="header-box" style="flex: 3">课程信息</div>
                    <div class="header-box" style="flex: 1">订单金额</div>
                    <div class="header-box" style="flex: 1">状态</div>
                    <div class="header-box" style="flex: 1">操作</div>
                </div>
                <div class="info-content">
                    <div class="content-box" style="flex: 3">
                        <div class="goods-info">
                            <img :src="order_info.order_info.course_img" alt="" class="goods-img">
                            <div class="info">
                                <div class="goods-name">{{order_info.order_info.course_name.length>25?order_info.order_info.course_name.substring(0,25)+'...':order_info.order_info.course_name}}</div>
                                <div class="goods-type">类别：食品安全培训</div>
                                <div class="goods-type">学时：{{order_info.order_info.cnt_course}}课时</div>
                            </div>
                        </div>
                    </div>
                    <div class="content-box" style="flex: 1">
                        <div class="goods-price">￥{{order_info.pay_money}}</div>
                    </div>
                    <div class="content-box" style="flex: 1">
                        <div class="status">{{order_info.order_status}}</div>
                    </div>
                    <div class="content-box" style="flex: 1">
                        <router-link class="handle-btn"
                                     :to="'/Gostudy?course_id=' + order_info.order_info.course_id">
                            查看课程
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="roll-shell">
                <div class="roll-tips" v-if="task_info.status==3">
                    <img src="@/assets/error.png" alt="" class="succeed-icon">
                    拼团失败
                </div>
                <div class="roll-tips" v-if="task_info.status==2 || (task_info.group_num -task_info.cnt_user==0)">
                    <img src="@/assets/zhifuchengg.png" alt="" class="succeed-icon">
                    拼团成功
                </div>
                <div class="user-list">
                    <div class="user-box" v-for="(item,index) in user_list" :key="index">
                        <img class="user-img" :src="item.head_img" alt=""/>
                        <div class="mass-head" v-if="item.is_head==1">团长</div>
                    </div>
                    <div class="user-box" v-for="(item,index) in task_info.diff_user" :key="index + 'a'"
                         v-if="task_info.status==0">
                        <img src="@/assets/why.png" alt="" style="border: none;"/>
                    </div>
                </div>
                <div class="roll-tips" v-if="task_info.status==0 && (task_info.group_num -task_info.cnt_user>0)">
                    还差{{task_info.group_num - task_info.cnt_user}}人拼团，呼唤小伙伴参加吧！
                </div>
                <div class="roll-tips" v-if="task_info.status==3">
                    已结束拼团，还差{{task_info.group_num - task_info.cnt_user}}人成团！
                </div>

                <div class="roll-time" v-if="task_info.status==0 && (task_info.group_num -task_info.cnt_user>0)">
                    <span></span>
                    剩余
                    <div class="time-list">
                        <div class="time-box">
                            {{task_info.end_time.substring(0,2)}}
                        </div>
                        :
                        <div class="time-box">
                            {{task_info.end_time.substring(3,5)}}
                        </div>
                        :
                        <div class="time-box">
                            {{task_info.end_time.substring(6.7)}}
                        </div>
                    </div>
                    结束
                    <span></span>
                </div>
                <div class="roll-bottom-handle">
                    <router-link class="handle-btn"
                                 :to="'/Coursetobuy?course_id=' + order_info.order_info.course_id">
                        返回
                    </router-link>
                    <router-link class="handle-btn" v-if="task_info.status==3" :to="'/refund-detail?member_id='+member_id +'&task_id='+task_id">退款详情</router-link>
                </div>
            </div>
        </div>

        <el-dialog
            :visible.sync="dialogVisible"
            width="30%"
            center>
            <div class="success">
                <h3>专属老师微信</h3>
                <p>快扫码添加你的专属老师微信</p>
                <img src="@/assets/teacher_wx.png" alt="" class="code">
                <div>服务时间：周一至周五8:30～17；30</div>
            </div>
            <span slot="footer"></span>
        </el-dialog>
    </div>
</template>

<script>
  export default {
    name: 'succeed',
    data () {
      return {
        is_order: false,
        task_id: '',
        member_id: '',
        order_id: '',
        order_info: {
          order_info: {
            course_img: '',
            course_name: '1'
          }
        },
        is_task: false,
        group_info: {},
        user_list: [],
        task_info: {
          end_time: '00:00:00:00',
          diff_user: []
        },
        dialogVisible: false,
        dataTime: ''
      }
    },
    created () {
        this.dataTime = setTimeout(() => {
            this.dialogVisible = true
        }, 3000);
    },
    beforeDestroy () {
        clearTimeout(this.dataTime)
    },
    mounted () {
      if (this.$route.query.is_order) {
        this.is_order = false
      } else {
        this.is_order = true
      }
      if (this.$route.query.task_id) {
        this.task_id = this.$route.query.task_id
        this.member_id = this.$route.query.member_id
        this.is_task = true
        this.get_detail()
      }
      if (this.$route.query.order_id) {
        this.order_id = this.$route.query.order_id
        this.get_order_detail()
      }
    },
    methods: {
      dif_time (endTime) {
        endTime = Number(endTime)
        function formatNumber (number) {
          return String(number).padStart(2, '0')
        }

        endTime = new Date(endTime * 1000)
        let startTime = new Date()
        let time_dif = endTime.getTime() - startTime.getTime() // 时间差
        if (time_dif <= 0) {
          // clearInterval(this.countDown)
          return '00:00:00'
        } else {
          // console.log(time_dif)
          //计算出小时数
          let lv1 = time_dif % (24 * 3600 * 1000)    //计算天数后剩余的毫秒数
          let h = Math.floor(lv1 / (3600 * 1000))
          //计算相差分钟数
          let lv2 = lv1 % (3600 * 1000)        //计算小时数后剩余的毫秒数
          let m = Math.floor(lv2 / (60 * 1000))
          //计算相差秒数
          let lv3 = lv2 % (60 * 1000)      //计算分钟数后剩余的毫秒数
          let s = Math.round(lv3 / 1000)
          let time = formatNumber(h) + ':' + formatNumber(m) + ':' + formatNumber(s)
          // console.log(d + '天,' + h + '小时,' + m + '分钟,' + s + '秒')
          return time
        }
      },
      get_detail () {
        let _this = this
        this.API.post('user/group-order_detail', {
          member_id: this.member_id,
        }).then((res) => {
          res.data.task_info.end_time = res.data.task_info.end_time.toString()
          this.group_info = res.data.group_info
          this.user_list = res.data.user_list
          this.task_info = res.data.task_info
          this.order_id = this.task_info.order_id
          let end_time = res.data.task_info.end_time
          setInterval(() => {
            _this.task_info.end_time = _this.dif_time(end_time)
          }, 1000)
          this.get_order_detail()
        })
      },
      get_order_detail () {
        this.API.post('user/user_infos-order_detail', {
          order_id: this.order_id
        }).then((res) => {
          this.order_info = res.data.order_info
        })
      }
    }
  }
</script>

<style lang="less" scoped>
    .max-view-shell {
        background-color: #fff;
        border: 1px solid #fff;
    }

    .pay-succed-shell {
        display: flex;
        align-items: center;
        width: 1200px;
        height: 120px;
        border: 1px solid #DCDCDC;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        padding-left: 60px;
        margin: 40px auto 30px;

        img {
            width: 42px;
            height: 42px;
            margin-right: 16px;
        }
    }

    .goods-info-shell {
        margin: 30px 0 27px;

        .info-header {
            display: flex;
            align-items: center;
            width: 1197px;
            height: 60px;
            background: #F8F8F8;
            border: 1px solid #E5E5E5;
            padding: 14px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;

            .header-box {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .info-content {
            display: flex;
            align-items: center;
            width: 1197px;
            height: 170px;
            background: #FFFFFF;
            border: 1px solid #E5E5E5;
            padding: 14px;

            .content-box {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .goods-info {
                display: flex;
                align-items: center;

                .goods-img {
                    width: 183px;
                    height: 110px;
                    margin-right: 12px;
                }

                .info {
                    .goods-name {
                        width: 239px;
                        height: 47px;
                        font-size: 18px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #000000;
                        margin-bottom: 16px;
                    }

                    .goods-type {
                        font-size: 14px;
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #999999;
                        margin-bottom: 10px;
                    }
                }
            }

            .goods-price {

                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #EB2020;
            }

            .status {
                font-size: 18px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
            }

            .handle-btn {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #2AA9B5;
            }
        }
    }

    .roll-shell {
        width: 1200px;
        height: 564px;
        background: #FFFFFF;
        border: 1px solid #E5E5E5;
        margin-bottom: 120px;

        .user-list {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 70px;

            .user-box {
                width: 90px;
                height: 90px;
                margin-right: 35px;
                position: relative;

                .user-img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    border: 2px solid rgb(255, 168, 0);
                }

                .mass-head {
                    position: absolute;
                    bottom: 0px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 70px;
                    height: 40px;
                    background: #FFA800;
                    border-radius: 5px;
                    font-size: 28px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                }
            }
        }

        .roll-tips {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            margin: 60px 0 40px;

            .succeed-icon {
                width: 40px;
                height: 40px;
                margin-right: 14px;
            }
        }

        .roll-time {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 26px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333333;

            span {
                width: 92px;
                height: 1px;
                background: #BFBFBF;
                margin: 0 20px;
            }

            .time-list {
                display: flex;
                align-items: center;
                font-size: 26px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #E70010;
            }

            .time-box {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 60px;
                height: 47px;
                background: #FFECE5;
                border-radius: 5px;
                font-size: 26px;
                font-family: PingFang SC;
                font-weight: bold;
                color: #E70010;
                margin: 0 18px;
            }
        }

        .roll-bottom-handle {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 68px;

            .handle-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 230px;
                height: 77px;
                border: 1px solid #2AA9B5;
                border-radius: 10px;
                font-size: 28px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #2AA9B5;
                margin-left: 20px;
            }
        }
    }

    .success {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h3 {
        margin: 25px 0;
        }
        p {
        color: #666666;
        margin-bottom: 25px;
        font-size: 14px;
        text-align: center;
        }
        .code {
        width: 150px;
        margin: 0 0 40px;
        }
    }
</style>
